// 2026-06-26: Full sidebar map for Page Access Master.
// Grouped by sidebar section so the admin sees the same hierarchy as users do.

export const SIDEBAR_GROUPS = [
  {
    section: 'LIVE',
    pages: [
      { value: 'kpi-dashboard',       label: 'KPI Dashboard' },
      { value: 'machinemm',           label: 'Machines' },
      { value: 'machine-status',      label: 'Machine Status' },
      { value: 'deviceoee',           label: 'OEE' },
      { value: 'teep',                label: 'TEEP' },
      { value: 'operator-performance',label: 'Operator Performance' },
      { value: 'operator-leaderboard',label: 'Operator Leaderboard' },
    ],
  },
  {
    section: 'PRODUCTION',
    pages: [
      { value: 'mes-planning',     label: 'MES Cockpit' },
      { value: 'scheduler',        label: 'Scheduler' },
      { value: 'labour-board',     label: 'Worker Board' },
      { value: 'work-orders',      label: 'Work Orders' },
      { value: 'operation-setup',  label: 'Operation Setup' },
      { value: 'operator-queue',   label: 'Operations Map' },
      { value: 'mes-reports',      label: 'MES Reports' },
      { value: 'nc-log',           label: 'NC Log' },
      { value: 'rework-orders',    label: 'Rework Orders' },
      { value: 'bom-master',       label: 'BOM' },
      { value: 'ecr',              label: 'ECR' },
      { value: 'ecn',              label: 'ECN' },
      { value: 'operator-details', label: 'Allocation' },
      { value: 'production-metrics', label: 'Metrics' },
      { value: 'holiday-list',     label: 'Holiday Calendar' },
    ],
  },
    { section: 'NADCAP', pages: [
      { value: 'nadcap-dashboard',      label: 'NADCAP · Compliance Cockpit' },
      { value: 'heat-treat-cycles',     label: 'Heat Treat Cycles' },
      { value: 'ndt-inspections',       label: 'NDT Inspections' },
      { value: 'anodize-batches',       label: 'Anodize Batches' },
      { value: 'route-card-follower', label: 'Route Card Follower' },
      { value: 'route-card-builder', label: 'Route Card Builder' },
      { value: 'jigging-panels', label: 'Jigging & Test Panels' },
      { value: 'material-certs',       label: 'Material Certificates' },
      { value: 'calibration-register',  label: 'Calibration Register' },
      { value: 'operator-qualifications', label: 'Operator Qualifications' },
      { value: 'audit-trail',           label: 'Audit Trail' },
  ]},
  {
    section: 'ENGINEERING',
    pages: [
      { value: 'paperless-factory/drawings', label: 'Drawings Library' },
      { value: 'paperless-factory/orders',   label: 'Drawing Orders' },
      { value: 'component-registration',     label: 'Components' },
      { value: 'production-analysis',        label: 'Component Analysis' },
      { value: 'analytics',                  label: 'Operation Analysis' },
      { value: 'gcode-optimizer',            label: 'G-Code Optimizer' },
    ],
  },
  {
    section: 'QUALITY & MAINTENANCE',
    pages: [
      { value: 'inspection/gauging',   label: 'Gauging' },
      { value: 'inspection/vernier',   label: 'Vernier Caliper' },
      { value: 'inspection/cmm',       label: 'CMM' },
      { value: 'inspection/ct-meter',  label: 'CT Meter' },
      { value: 'inspection/tool-wear', label: 'Tool Wear' },
      { value: 'inspection/devices',   label: 'Device Settings' },
      { value: 'bluecard',             label: 'Blue Card Entry' },
      { value: 'quality',              label: 'Quality Entry' },
      { value: 'bluecardreport',       label: 'Blue Card Report' },
      { value: 'reports',              label: 'Reports' },
      { value: 'erpreport',            label: 'ERP Report' },
      { value: 'maintenance-dashboard',label: 'Maintenance' },
      { value: 'tool-dashboard',       label: 'Tool Life' },
    ],
  },
  {
    section: 'BUSINESS (ERP)',
    pages: [
      { value: 'sales',     label: 'Sales' },
      { value: 'purchase',  label: 'Purchase' },
      { value: 'inventory', label: 'Inventory' },
      { value: 'bom',       label: 'BOM (Business)' },
      { value: 'mrp',       label: 'MRP' },
      { value: 'finance',   label: 'Finance' },
      { value: 'crm',       label: 'CRM' },
      { value: 'workforce', label: 'Workforce' },
      { value: 'insights',  label: 'Insights' },
      { value: 'erpjson',   label: 'Legacy ERP' },
    ],
  },
  {
    section: 'SETTINGS',
    pages: [
      { value: 'user-registration',  label: 'Users' },
      { value: 'group',              label: 'Groups' },
      { value: 'shift-registration', label: 'Shifts' },
      { value: 'process-master',     label: 'Process Master' },
      { value: 'sites',              label: 'Sites' },
      { value: 'floor-layout',       label: 'Floor Layout' },
      { value: 'machines',           label: 'Machines Master' },
      { value: 'machines-group',     label: 'Machine Group' },
      { value: 'machine-capabilities', label: 'Work Center Capabilities' },
      { value: 'calibration-register', label: 'Calibration Register' },
      { value: 'operator-qualifications', label: 'Operator Qualifications' },
      { value: 'heat-treat-cycles', label: 'Heat Treat Cycles' },
      { value: 'ndt-inspections', label: 'NDT Inspections' },
      { value: 'anodize-batches', label: 'Anodize Batches' },
      { value: 'route-card-follower', label: 'Route Card Follower' },
      { value: 'route-card-builder', label: 'Route Card Builder' },
      { value: 'jigging-panels', label: 'Jigging & Test Panels' },
      { value: 'audit-trail', label: 'Audit Trail' },
      { value: 'reason-registration', label: 'Reasons' },
      { value: 'settings',           label: 'General Settings' },
      { value: 'notification-center',label: 'Notification Center' },
      { value: 'erpreportschedule',  label: 'Email Schedule' },
      { value: 'paperless-factory/settings', label: 'Paperless Settings' },
      { value: 'page-access',        label: 'Page Access' },  // self
    ],
  },
];

// Backward-compat flat list (consumed by old User Registration page)
export const PAGE_LIST = SIDEBAR_GROUPS.flatMap(g => g.pages);

export const QUALITY_PAGELIST = [
  { value: 'quality',        label: 'Quality Entry' },
  { value: 'bluecard',       label: 'Blue Card' },
  { value: 'bluecardreport', label: 'Blue Card Report' },
  { value: 'reports',        label: 'Reports' },
];

// Role presets — admin can apply with one click
export const ROLE_PRESETS = {
  Operator: ['operator'],
  Supervisor: [
    'kpi-dashboard', 'machine-status', 'deviceoee',
    'mes-planning', 'scheduler', 'work-orders', 'operator-queue', 'mes-reports',
    'nc-log', 'rework-orders', 'labour-board', 'operator-details',
    'maintenance-dashboard', 'tool-dashboard',
  ],
  'Quality': [
    'kpi-dashboard', 'machine-status',
    'inspection/gauging', 'inspection/vernier', 'inspection/cmm', 'inspection/ct-meter',
    'inspection/tool-wear', 'inspection/devices',
    'bluecard', 'quality', 'bluecardreport', 'nc-log', 'reports',
  ],
  Manager: [
    // Everything except the admin-only settings
    ...SIDEBAR_GROUPS.flatMap(g =>
      g.section === 'SETTINGS' ? [] : g.pages.map(p => p.value)
    ),
    'user-registration', 'group', 'shift-registration', 'reason-registration',
  ],
  Admin: SIDEBAR_GROUPS.flatMap(g => g.pages.map(p => p.value)),
};
